import { useEffect, useState } from "react";
import Table from "../../Reusable/Table/Table1";
import {
  UserOutlined,
  EyeOutlined,
  WalletOutlined,
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  StopOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  EditOutlined,
  CopyOutlined,
} from "@ant-design/icons";
import DropdownButton from "../../Reusable/dropdown/Drop";
import ReusableModal from "../../Reusable/Model/Model";
import ReusableDrawer from "../../Reusable/Drawer/Drawer";
import EditableTable from "../../Reusable/Table/EditableTable";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Tag,
  message,
  Input,
  Badge,
  Button,
  Form,
  Select,
  Image,
  Segmented,
  Modal,
} from "antd";
import consts from "../../constant";
import { type } from "@testing-library/user-event/dist/type";
import Loadingpage from "../Loadingpage/Loadingpage";
import ExportButton from "../../Reusable/ExportButton/ExportButton";

const Users = () => {

  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [openBlock, setOpenBlock] = useState(false);
  const [openBlock2, setOpenBlock2] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [formLayout] = useState("vertical");
  const [form] = Form.useForm();
  const [page, setPage] = useState({ current: 1, pageSize: 10 });
  const [sort, setSort] = useState({ field: 'createdAt', order: 'descend' });
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openViewDrawer, setOpenViewDrawer] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("false");
  const [messageApi, contextHolder] = message.useMessage();
  const [users, setUsers] = useState([]);
  const [total, setTotal] = useState(0);
  const [status, setStatus] = useState(false);
  const [block, setBlock] = useState(null);
  const [search, setSearch] = useState("");
  const [searchTrigger, setSearchTrigger] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState(
    "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png"
  );
  const [filters, setFilters] = useState({
    search: "",
  });
  const [wallet, setWallet] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [isModalOpen, setIsModalOpen] = useState(false);

  const { Search } = Input;

  // const onSearch = (value, _e, info) =>
  //   console.log(info?.source, value, "snakar");

  // const success = () => {
  //   messageApi.open({
  //     type: "success",
  //     content: "Status Updated",
  //   });
  // };

  // const showDrawer = (user) => {

  //   // setSelectedUser(user);
  //   setOpenDrawer(true);
  // };

  const onClose = () => {
    setOpenDrawer(false);
    setSelectedUser(null);
    setOpenViewDrawer(false);
  };

  // const showModalBlock = (val) => {
  //   setOpenBlock(true);
  //   setSelectedUser(val);
  //   setStatus(val?.status);
  //   setBlock(val?.block);
  // };


  // const showModalBlock2 = (val) => {

  //   setOpenBlock2(true);
  //   setSelectedUser(val);
  //   setBlock(val?.block);
  //   setStatus(val?.status);
  // };

  // const handleOkBlock = () => {
  //   // setModalText("The modal will be closed after two seconds");
  //   setConfirmLoading(true);
  //   setStatus(!status);
  //   setTimeout(() => {
  //     setOpenBlock(false);
  //     setConfirmLoading(false);
  //     getUserStatus(!status, block);
  //     success();
  //   }, 2000);
  // };

  // const handleOkBlock2 = () => {
  //   // setModalText("The modal will be closed after two seconds");
  //   setConfirmLoading(true);
  //   setBlock(!block);

  //   setTimeout(() => {
  //     setOpenBlock2(false);
  //     setConfirmLoading(false);
  //     getUserStatus(status, !block);

  //     success();
  //   }, 2000);
  // };

  // const handleCancelBlock = () => {
  //   setOpenBlock(false);
  // };

  // const handleCancelBlock2 = () => {
  //   setOpenBlock2(false);
  // };
  // const handleMenuClick = (e, user) => {
  //   console.log("Clicked:", e);
  //   if (e.key === "1") {
  //     // View
  //     showDrawer(user);
  //   }
  //   if (e.key === "2") {
  //     navigate(`/${consts.route}/userwallet`, { state: { user } });
  //   }
  //   if (e.key === "3") {
  //     showModalBlock(user);
  //   }
  //   if (e.key === "4") {
  //     showModalBlock2(user);
  //   }
  // };

  // const items = (user) => [
  //   { label: "View", key: "1", icon: <EyeOutlined /> },
  //   { label: "Wallet", key: "2", icon: <WalletOutlined /> },
  //   {
  //     label: user?.verified !== "true" ? "Verify" : "Un-Verify",
  //     key: "3",
  //     icon: <UserOutlined />,
  //   },
  //   {
  //     label: user?.block ? "Unblock" : "Block", // 👈 dynamic text
  //     key: "4",
  //     icon: <StopOutlined />,
  //   },
  // ];

  const formatNumber = (val) => {
    const num = parseFloat(val || 0);

    if (Number.isInteger(num)) {
      return num; // show 1
    }

    return num.toFixed(6); // show decimals
  };

  const userColumns = [
    { title: "Sno", dataIndex: "sno", key: "sno" },
    {
      title: "Profile Image",
      dataIndex: "profile_image",
      key: "profile_image",
      render: (_, record) => {
        return record?.profile_image ? (
          <Image
            width={40}
            height={40}
            style={{
              borderRadius: "50%",
              objectFit: "cover",
              border: "1px solid #FC4420",
              cursor: "pointer",
            }}
            src={record?.profile_image}
            preview={{
              mask: "Click to Preview",
            }}
          />
        ) : (
          <div
            style={{
              width: 40,
              height: 40,
              borderRadius: "50%",
              border: "1px solid #FC4420",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#FC4420",
              fontWeight: "bold",
              fontSize: "18px",
              textTransform: "uppercase",
            }}
          >
            {record?.name?.charAt(0) || "U"}
          </div>
        );
      },
    },

    { title: "Name", dataIndex: "name", key: "name", searchable: true },
    { title: "Email", dataIndex: "email", key: "email", width: "20%" },
    // { title: "User ID", dataIndex: "userId", key: "userId", width: "20%" },
    // { title: "Balance", dataIndex: "balance", key: "balance", width: "20%" },
    // { title: "Profit", dataIndex: "profit", key: "profit", width: "20%" },
    // { title: "Escrow", dataIndex: "escrow_balance", key: "escrow_balance", width: "20%" },
    {
      title: "Balance",
      dataIndex: "balance",
      key: "balance",
      width: "20%",
      //   sorter: (a, b) => parseFloat(a.balance || 0) - parseFloat(b.balance || 0),
      //   sortDirections: ["descend", "ascend"],
      //   render: (val) => formatNumber(val),
    },
    {
      title: "Profit",
      dataIndex: "profit",
      key: "profit",
      width: "20%",
      // sorter: (a, b) => parseFloat(a.profit || 0) - parseFloat(b.profit || 0),
      // sortDirections: ["descend", "ascend"],
      // render: (val) => formatNumber(val),
    },
    // {
    //   title: "Escrow",
    //   dataIndex: "escrow_balance",
    //   key: "escrow_balance",
    //   width: "20%",
    //   sorter: (a, b) =>
    //     parseFloat(a.escrow_balance || 0) - parseFloat(b.escrow_balance || 0),
    //   sortDirections: ["descend", "ascend"],
    //   render: (val) => formatNumber(val),
    // },
    // {
    //   title: "Phone",
    //   dataIndex: "phone",
    //   key: "phone",
    //   // sorter: (a, b) => a.address.length - b.address.length,
    //   // sortDirections: ["descend", "ascend"],
    // },
    // { title: "Referral Code", dataIndex: "ref", key: "ref" },

    // { title: "Status", dataIndex: "status", key: "status" },
    {
      title: "Action",
      key: "select",
      // fixed: "right",
      render: (_, record) => (
        <Button
          type="link"
          icon={<EditOutlined />}
          onClick={() => handleView(record)}
          style={{ color: "#FC4420" }}
        >
          View
        </Button>
      ),
    },
  ];

  const handlePagination = (pagination, filters, sorter) => {
    console.log("Table params:", pagination, sorter);
    setPage(pagination);
    if (sorter && sorter.field) {
      setSort({
        field: sorter.field,
        order: sorter.order || 'descend'
      });
    } else if (sorter && !sorter.field) {
      // Clear sorting if needed
      setSort({ field: 'createdAt', order: 'descend' });
    }
  };

  const handleClear = () => {
    setFilters({
      search: "",
    });
    setSearchTrigger("");

    setPage({ current: 1, pageSize: 10 });
    setSort({ field: 'createdAt', order: 'descend' });
  };

  const handleView = async (record) => {
    setSelectedUser(record);
    setSelectedStatus(record?.status);
    form.setFieldsValue({
      username: record?.name,
      status: record?.status === "true" ? "Active" : "In-Active",
    });
    try {
      const response = await axios.post(
        `${consts.BackendUrl}/users/getWallet`,
        { user_id: record.key },
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
          },
        }
      );
      if (response?.data?.success) {
        const resultData = response?.data?.result;
        const walletArray = Array.isArray(resultData) ? resultData : (resultData ? [resultData] : []);
        form.setFieldsValue({
          type: walletArray[0]?.type,
          balance: walletArray[0]?.balance,
          profit: walletArray[0]?.profit,
          escrow_balance: walletArray[0]?.escrow_balance,
        });
        setWallet(walletArray);
        setOpenViewDrawer(true);

      } else {
        form.setFieldsValue({
          balance: 0,
        });
        // form.resetFields([ "balance"]);
        setWallet([]);
        // setSelectedUser(null);
        setOpenViewDrawer(true);
      }
    } catch (error) {
      form.resetFields();
      setSelectedUser(null);
      setWallet([]);
      console.log(error);
    }
  };

  const getUsers = async () => {
    try {
      setConfirmLoading(true);
      const { data } = await axios.post(
        `${consts.BackendUrl}/users/profile`,
        {
          search: searchTrigger,
          page: page?.current ? page?.current : 1,
          limit: page?.pageSize ? page?.pageSize : 10,
          sortField: sort.field,
          sortOrder: sort.order
        },
        // {},
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
          },
        }
      );
      if (data?.success === true && data?.result?.length > 0) {
        var dts = await data?.result;

        // Map backend data into the table format
        setTotal(data?.total);
        const mappedData = await dts.map((user, index) => ({
          key: user._id, // must be uniqueoffset={[10, 10]}
          sno: page?.current
            ? (page?.current - 1) * page?.pageSize + index + 1
            : index + 1,
          profile_image: user?.profile_image,

          name: user?.name,
          // <Badge
          //   count={
          //     user?.block ? <StopOutlined style={{ color: "#f5222d" }} /> : 0
          //   }
          //   offset={[15, 7]}
          // >
          // </Badge>
          email: user?.email,
          // phone: user?.phone,
          // ref: user?.referral_code,
          // status:
          //   user?.verified == "true" ? (
          //     <Tag icon={<CheckCircleOutlined />} color="success">
          //       Verified
          //     </Tag>
          //   ) : (
          //     <Tag icon={<ExclamationCircleOutlined />} color="warning">
          //       Un-Verified
          //     </Tag>
          //   ),
          // select: (
          //   <DropdownButton
          //     items={items(user)}
          //     label="More"
          //     onMenuClick={(e) => {
          //       handleMenuClick(e, user);
          //       setStatus(JSON.parse(user?.verified));
          //     }}
          //   />
          // ),
          balance: user?.balance,
          profit: user?.profit,
          // escrow_balance: user?.escrow_balance,
          status: user?.status,
          // userId: user?.user_id ? (
          //   <>
          //     {" "}
          //     {`${user?.user_id?.slice(0, 5)}...${user?.user_id?.slice(
          //       -5,
          //     )}`}{" "}
          //     <CopyOutlined
          //       onClick={() =>
          //         navigator.clipboard
          //           .writeText(user?.user_id)
          //           .then(() => {
          //             messageApi.open({
          //               type: "success",
          //               content: "Copied to clipboard",
          //             });
          //           })
          //           .catch((err) => {
          //             messageApi.open({
          //               type: "error",
          //               content: "Failed to copy",
          //             });
          //             console.error("Failed to copy: ", err);
          //           })
          //       }
          //     />
          //   </>
          // ) : (
          //   "-"
          // ),
        }));

        setUsers(mappedData);
        setConfirmLoading(false);
      } else {
        setUsers([]);
        setTotal(0);
        setConfirmLoading(false);
      }
    } catch (error) {
      console.log(error?.response?.data?.message);
      setUsers([]);
      setTotal(0);
      setConfirmLoading(false);
    }
  };

  // const getUserStatus = async (status, block) => {
  //   try {
  //     const { data } = await axios.post(
  //       `${consts.BackendUrl}/admin/updateuserverifydetails`,
  //       {
  //         status: status,
  //         userId: selectedUser?._id,
  //         email_verify: selectedUser?.email_verify,
  //         kyc_verify: selectedUser?.kyc_verify,
  //         f2A_Status: selectedUser?.f2A_Status,
  //         block: block,
  //       },
  //       {
  //         headers: {
  //           Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
  //         },
  //       }
  //     );
  //     if (data?.status === true) {
  //       getUsers();
  //       // setStatus();
  //     } else {
  //       // setTwoFa(false);
  //       // handleClose();
  //     }
  //   } catch (error) {
  //     console.log(error, "error");
  //   }
  // };

  //   useEffect(() => {
  //     getUsers();
  //   }, []);

  const onFinish = async (values) => {
    try {
      setLoading(true);
      if (values?.balance <= 0) {
        return messageApi.open({
          type: "error",
          content: "Wallet balance should be greater than 0",
        });
      }
      // console.log(selectedUser?.status, values?.status, "oudijdjd");
      // if ( selectedUser?.status != (values?.status === "Active" ? "true" : "false")  ) {
      //   const response = await axios.patch(
      //     `${consts.BackendUrl}/users/update/${selectedUser?.key}`,
      //     {
      //       id: selectedUser?.key,
      //       status: values?.status === "Active" ? "true" : "false",
      //     },
      //     {
      //       headers: {
      //         Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
      //       },
      //     }
      //   );
      // }
      const response = await axios.post(
        `${consts.BackendUrl}/updateUserWallet`,
        {
          userid: selectedUser?.key,
          walletBalance: values?.balance,
        },
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
          },
        }
      );

      if (response?.data?.success) {
        messageApi.open({
          type: "success",
          content: "Updated successfully",
        });
        getUsers();
        setOpenViewDrawer(false);
      } else {
        messageApi.open({
          type: "error",
          content: "Failed to update",
        });
      }
    } catch (error) {
      console.log(error);
      messageApi.open({
        type: "error",
        content: error?.response?.data?.message || "Failed to update wallet",
      });
    } finally {
      setLoading(false);
    }
  };

  const onChange = async (e) => {
    const filterWalletByType = wallet?.filter((item) => {
      return e === item?.type;
    });

    form.setFieldsValue({
      type: e,
      balance: filterWalletByType?.[0]?.balance || 0,
    });
  };

  useEffect(() => {
    // 🧪 Dummy test data
    getUsers();
  }, [page.current, page.pageSize, sort.field, sort.order, searchTrigger]);
  //Debounced Search
  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     getUsers();
  //   }, 500);
  //   return () => clearTimeout(timer);
  // }, [search]);

  return (
    //user wallet history
    <>
      <Loadingpage />
      <div className="display-2 p-10" style={{ gap: '10px', alignItems: 'center', flexWrap: 'wrap', }}>
        <h2>Users Wallet </h2>
        <div style={{ display: 'flex', gap: '10px', marginLeft: 'auto', flexWrap: 'wrap' }}>
          <Select
            allowClear
            placeholder="Balance"
            style={{ width: 140 }}
            onChange={(val) => {
              setSort({ field: 'balance', order: val });
              setPage((prev) => ({ ...prev, current: 1 }));
            }}
            value={sort.field === 'balance' ? sort.order : undefined}
          >
            <Select.Option value="descend">High to Low</Select.Option>
            <Select.Option value="ascend">Low to High</Select.Option>
          </Select>
          <Select
            allowClear
            placeholder="Profit"
            style={{ width: 140 }}
            onChange={(val) => {
              setSort({ field: 'profit', order: val });
              setPage((prev) => ({ ...prev, current: 1 }));
            }}
            value={sort.field === 'profit' ? sort.order : undefined}
          >
            <Select.Option value="descend">High to Low</Select.Option>
            <Select.Option value="ascend">Low to High</Select.Option>
          </Select>
          {/* <Select
            allowClear
            placeholder="Escrow"
            style={{ width: 140 }}
            onChange={(val) => {
              setSort({ field: 'escrow_balance', order: val });
              setPage((prev) => ({ ...prev, current: 1 }));
            }}
            value={sort.field === 'escrow_balance' ? sort.order : undefined}
          >
            <Select.Option value="descend">High to Low</Select.Option>
            <Select.Option value="ascend">Low to High</Select.Option>
          </Select> */}
          <Input.Search
            placeholder="Search for name"
            value={filters.search}
            onChange={(e) => {
              const value = e.target.value;

              setFilters((f) => ({
                ...f,
                search: value,
              }));

              if (!value) {
                setSearchTrigger("");

                setPage({
                  current: 1,
                  pageSize: 10,
                });
              }
            }}
            onSearch={(v) => {
              setSearchTrigger(v);
              setPage((prev) => ({
                ...prev,
                current: 1,
              }));
            }}
            allowClear
            style={{ width: 180 }}
            loading={confirmLoading}
            className="input-cls"
          />
          <Button
            onClick={handleClear}
            icon={<CloseCircleOutlined />}
            loading={confirmLoading}
            disabled={confirmLoading}
          >
            Clear
          </Button>
          <ExportButton
            category="wallets"
            filters={{
              status: status,
              block: block,
              search: search,
              sort: sort,
              page: page,
            }}
          />
        </div>
      </div>
      <EditableTable
        columnsConfig={userColumns}
        dataSource={users}
        className="mt-20"
        total={total} // 👈 pass backend total here
        pageSize={10}
        current={page?.current ? page?.current : 1}
        closeDisabled={true}
        onChange={handlePagination}
        loading={confirmLoading}

      // completeTrade={editTrade}
      // newValues={newValues}
      />

      {/* <ReusableModal
        title="Update Status"
        open={openBlock}
        onOk={handleOkBlock}
        confirmLoading={confirmLoading}
        onCancel={handleCancelBlock}
        className="table-clr"
      >
        <p>
          Are you sure you want to{" "}
          {selectedUser?.verified == "true" ? (
            <Tag icon={<ExclamationCircleOutlined />} color="warning">
              Un Verify
            </Tag>
          ) : (
            <Tag icon={<CheckCircleOutlined />} color="success">
              Verify
            </Tag>
          )}{" "}
          <strong>{selectedUser?.name} ?</strong>
        </p>
      </ReusableModal>

      <ReusableModal
        title="Update Status"
        open={openBlock2}
        onOk={handleOkBlock2}
        confirmLoading={confirmLoading}
        onCancel={handleCancelBlock2}
        className="table-clr"
      >
        <p>
          Are you sure you want to {selectedUser?.block ? "UnBlock" : "Block"}
          <strong> {selectedUser?.name} ?</strong>
        </p>
      </ReusableModal>

      <ReusableDrawer
        open={openDrawer}
        onClose={onClose}
        title="User Profile"
        className="table-clr"
      >
        {selectedUser ? (
          <div>
            <p>
              <b>Name:</b> {selectedUser.name}
            </p>
            <p>
              <b>Email:</b> {selectedUser.email}
            </p>
            <p>
              <b>Phone:</b> {selectedUser.phone}
            </p>
            <p>
              <b>Referral Code:</b> {selectedUser.referral_code}
            </p>
            <p>
              <b>Status:</b>{" "}
              {selectedUser.email_verify == "true" ? (
                <Tag icon={<CheckCircleOutlined />} color="success">
                  Verified
                </Tag>
              ) : (
                <Tag icon={<ExclamationCircleOutlined />} color="warning">
                  Un-Verified
                </Tag>
              )}
            </p>
          </div>
        ) : (
          <p>No user selected</p>
        )}
      </ReusableDrawer> */}

      <Modal
        open={openViewDrawer}
        onCancel={onClose}
        title="View"
        footer={null}
        maskClosable={false}
        centered
        maskStyle={{
          backdropFilter: "blur(8px)",
          backgroundColor: "rgba(0, 0, 0, 0.2)",
        }}
        styles={{
          content: {
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(255, 255, 255, 0.2)",

          },
          header: {
            backgroundColor: "transparent",
          },
        }}
      >
        <Form
          layout={formLayout}
          form={form}
          onFinish={onFinish}
          style={{ maxWidth: 600 }}
        >
          {/* <Form.Item label="Username" name="username">
            <Input style={{ width: "100%" }} type="text" readOnly />
          </Form.Item>
          <Form.Item
            label="Type"
            name="type"
            rules={[{ required: true, message: "Please select type" }]}
          >
            <Select placeholder="Select type" name="type" onChange={onChange}> */}
          {/* <Select.Option value="Crypto">Crypto</Select.Option>
              <Select.Option value="Stablecoin">Stablecoin</Select.Option>
              <Select.Option value="Token">Token</Select.Option>
              <Select.Option value="NFT">NFT</Select.Option> */}
          {/* <Select.Option value="USD">USD</Select.Option>
            </Select>
          </Form.Item> */}

          <Form.Item label="Balance" name="balance">
            <Input
              style={{ width: "100%" }}
              type="number"
              onChange={(e) => {
                // const value = e.target.value.replace(/[^0-9]/g, "").slice(0, 8);
                form.setFieldsValue({ balance: e.target.value });
              }}
            />
          </Form.Item>
          {/* <Form.Item name="status" label="Status">
            <Segmented options={["Active", "In-Active"]} />
          </Form.Item> */}
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              disabled={loading}
            >
              Update
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      {contextHolder}
    </>
  );
};

export default Users;
